export default "__VITE_ASSET__BfTTYf0l__"